<template>
    <alert type="danger" align="top" class="mb-3">
        <div class="d-flex flex-column flex-sm-row">
            <p class="mb-2 mb-sm-0 text-center text-sm-start">{{ flashData }}</p>
        </div>
    </alert>
</template>

<script>
    export default {
        props: ['flashData']
    }
</script>

<style lang="scss" scoped>

</style>